'use client';

import { c as _c } from "react/compiler-runtime";
import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';
function Collapsible(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <CollapsiblePrimitive.Root data-slot="collapsible" {...props} data-sentry-element="CollapsiblePrimitive.Root" data-sentry-component="Collapsible" data-sentry-source-file="collapsible.tsx" />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function CollapsibleContent(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <CollapsiblePrimitive.Panel data-slot="collapsible-content" {...props} data-sentry-element="CollapsiblePrimitive.Panel" data-sentry-component="CollapsibleContent" data-sentry-source-file="collapsible.tsx" />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function CollapsibleTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <CollapsiblePrimitive.Trigger data-slot="collapsible-trigger" {...props} data-sentry-element="CollapsiblePrimitive.Trigger" data-sentry-component="CollapsibleTrigger" data-sentry-source-file="collapsible.tsx" />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { Collapsible, CollapsibleContent, CollapsibleTrigger };